import Rewards from '@components/ReferAndEarn/Rewards';
import ReferAndEarnBanner from '@components/ReferAndEarn/ReferAndEarnBanner';
import RewardSteps from '@components/ReferAndEarn/RewardSteps';
import ReferEarnFaq from '@components/ReferAndEarn/ReferEarnFaq';
import { Image } from '@atoms/index';
import DoubleRewardsBanner from './DoubleRewardsBanner';
import { hasOffer } from './helper';

const ReferAndEarn = ({ referralLink = null }) => {
    return (
        <div>
            <div className="relative bg-basicWhite">
                <div className="relative flex flex-col gap-8 md:gap-12 lg:gap-[72px] z-10">
                    <ReferAndEarnBanner referralLink={referralLink} />
                    {hasOffer && <DoubleRewardsBanner />}
                    <div>
                        <Rewards />
                        <RewardSteps />
                        <ReferEarnFaq />
                    </div>
                </div>
                <div className='hidden md:block'>
                    <Image
                        src="/images/refer-and-earn/refer-earn-bg.svg"
                        className="absolute top-0 left-0 z-[1] w-full h-[630px]"
                        alt="bg-image"
                    />
                </div>
                <div className='md:hidden'>
                    <Image
                        src="/images/refer-and-earn/refer-earn-mobile-bg.svg"
                        className="absolute top-0 left-0 z-[1] w-full h-[500px]"
                        alt="bg-image"
                    />
                </div>
            </div>
        </div>
    );
};

export default ReferAndEarn;
